import { FC } from 'react';
import { Button } from '@carbon/react';
import { Add } from '@carbon/react/icons';
import { useAtomValue, useSetAtom } from 'jotai';
import classNames from 'classnames';
import { PageHeader } from 'components/page-header';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from 'utils/page-title';
import { FormationManagementContent } from './formation-management-content';
import {
  geologicIntervalDrawerStateAtom,
  openAddGeologicIntervalAtom,
} from './geologic-interval-drawer';
import styles from './formation-management.module.scss';

export const FormationManagementPage: FC = () => {
  const openAddInterval = useSetAtom(openAddGeologicIntervalAtom);
  const drawerOpen =
    useAtomValue(geologicIntervalDrawerStateAtom).mode !== null;

  return (
    <>
      <Helmet>
        <title>{pageTitle('Formation Management')}</title>
      </Helmet>
      <div
        className={classNames(
          styles.pageShell,
          drawerOpen && styles.pageShellWithDrawer
        )}
      >
        <PageHeader
          title="Formation Management"
          breadcrumbs={[]}
          actions={
            <Button
              size="md"
              kind="primary"
              renderIcon={Add}
              onClick={() => openAddInterval()}
            >
              Add Geologic Interval
            </Button>
          }
        />
        <div className={styles.pageContainer}>
          <div className={styles.pageBody}>
            <FormationManagementContent />
          </div>
        </div>
      </div>
    </>
  );
};
